import React from "react";
import { cn } from "@/lib/utils";

const TONE = {
  "Class 1": "border-emerald-300 text-emerald-800 bg-emerald-50",
  "Class 2": "border-amber-300 text-amber-800 bg-amber-50",
  "Class 3": "border-rose-300 text-rose-800 bg-rose-50",
};

export const ContributorClassTag = ({ value, count, className }) => (
  <span
    className={cn(
      "inline-flex items-center gap-1.5 px-2 py-0.5 rounded border text-[11px] font-mono uppercase tracking-wider",
      TONE[value] || "bg-slate-50 text-slate-700 border-slate-200",
      className,
    )}
    data-testid={`contributor-class-${value}`}
  >
    {value}
    {typeof count === "number" && <span className="opacity-70">· {count}</span>}
  </span>
);

export default ContributorClassTag;
